export enum SpecialStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    UNMONITORED = 'UNMONITORED',
    UNKNOWN = 'UNKNOWN'
}

export enum BarrierType {
    THREAT = 'prevention',
    CONSEQUENCE = 'mitigation'
}

export enum Entity {
    ESCALATION_FACTOR = 'escalation_factor',
    CONTROL_BARRIER = 'control_barrier',
    BARRIER = 'barrier',
    THREAT = 'threat',
    CONSEQUENCE = 'consequence',
    TOP_EVENT = 'top_event'
}

// export enum EventTypes {
//     BARRIER = '__dra_barrier',
//     TOPEVENT = '__dra_topevent',
//     ESCALATION = '__dra_escalation',
//     THREAT = '__dra_threat',
//     CONSEQUENCE = '__dra_escalation',
//     ALARM = '__dra_alarms'
// }

export enum OrderFields {
    RESOURCE = 'resource',
    BOWTIECODE = 'bowtieCode',
    BARRIER_ID = 'barrierId',
    ID = 'id',
    BARRIER_NAME = 'barrierName',
    INITIAL_PFD = 'initialPFD',
    FINAL_PFD = 'finalPFD',
    THRESHOLD = 'threshold',
    STATUS = 'status',
    DATE = 'date',
    TYPE = 'type',
    ENTITY = 'entity',
    CATEGORY = 'category',
    CRITICAL = 'critical',
    SAFETY_CRITICAL = 'safety_critical',
    RESPONSIBLE = 'responsible',
    RISKLEVEL = 'risklevel',
    BOWTIE_NAME = 'bowtieName',
    FINAL_FREQUENCY = 'finalFrequency',
    INITIAL_FREQUENCY = 'initialFrequency',
    THREAT_NAME = 'threatName',
    MOC = 'moc',
    TIME_GATHERED = 'totalTime',
    TIME_INTERVAL = 'timeInterval',
    METHOD = 'method',
    UPDATE_MODE = 'updateMode',
    SYSTEM_ID = 'systemId',



    // ESCALATION FACTOR REPORT

    ESCALATION_FACTOR_NAME = 'escalationFactorName',
    ESCALATION_FACTOR_ID = 'escalationFactorId',
    CONTRIBUITION = 'contribuition',
    FATHER_BARRIER_NAME = 'fatherBarrierName',
    FATHER_BARRIER_ID = 'fatherBarrierId',
    RESPONSIBLE_PERSON = 'responsiblePerson',

    // CONTROL BARRIER REPORT
    ESCALATION_FACTOR_CONTROL_BARRIER_NAME = 'escalationFactorControlBarrierName',
    ESCALATION_FACTOR_CONTROL_BARRIER_ID = 'escalationFactorControlBarrierId',
    ROOT_BARRIER_ID = 'rootBarrierId',

    // TOP EVENT REPORT
    TOP_EVENT_ID = 'topEventId',
    ALARP = 'alarp',
    EFFECTIVENESS_BOTTOM = 'effectivenessBottom',
    EFFECTIVENESS_TOP = 'effectivenessTop',

    // THREAT EVENT REPORT
    THREAT_ID = 'threatId',

    // CONSEQUENCE EVENT REPORT
    CONSEQUENCE_ID = 'consequenceId',
    CONSEQUENCE_NAME = 'consequenceName'
}

export enum SafetyCritical {
    BOWTIE_MANDATORY_BARRIER = 'Bowtie Mandatory Barrier',
    THREAT_MANDATORY_BARRIER = 'Threat Mandatory Barrier',
    CONSEQUENCE_MANDATORY_BARRIER = 'Consequence Mandatory Barrier'
}

export enum SystemProperty {
    ABSOLUTE = 'ABSOLUTE',
    RELATIVE = 'RELATIVE'
}

export enum UpdateModeMethods {
    QUANTITATIVE = 'QUANTITATIVE',
    QUALITATIVE = 'QUALITATIVE'
}

export enum UpdateModeMethodId {
    QUANTITATIVE_LIVE_EVENT = 'quantitative_live_event',
    QUANTITATIVE_LOPA_SCALING = 'lopa',
    QUANTITATIVE_LOPA_SCALING_WITH_CONTRIBUTION = 'lopa_with_contribution',
    QUALITATIVE_LIVE_EVENT = 'qualitative_live_event',
    QUALITATIVE_LOPA_SCALING = 'lopa_qualitative',
    QUANTITATIVE_RULED_CHANNEL = 'ruled_channel_quantitative'
}

export enum HoldFunction {
    MIN = 'MIN',
    MAX = 'MAX',
    NONE = 'NONE'
}

export enum AlarmColors {
    FATAL = 'FATAL',
    WARN = 'WARN',
    ERROR = 'ERROR',
    INFO = 'INFO'
}

export enum AlarmEntity {
    TOPEVENT = 'TOP_EVENT',
    BARRIER = 'BARRIER'
}

export enum AlarmAcknowledge {
    FALSE_ALARM = 'false',
    TRUE_ALARM = 'true',
    DISMISS_ALARM = 'dismiss',
    MISSING_ALARM = 'missing'
}

export enum AlarpMethod {
    QUANTITATIVE = 'QUANTITATIVE',
    QUALITATIVE = 'QUALITATIVE',
    NULL = 'NULL'
}
